import { Paths } from "../../constants/UrlConstants";
import axios from "./../AxiosService";

export const getNotificationsForMembershipNumber = membershipNumber => {
  return axios
    .get(Paths.Notifications, {
      avoidLoadingFeature: true,
      params: {
        membershipNumber
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
};

export const deleteNotificationBySecurityId = securityId => {
  return axios
    .delete(Paths.Notifications, {
      params: {
        securityId
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
};
